module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/8-cb496ee091bcd574728dc34ccc11e942.webm";